<template>
    <div class="filter-bar-header hidden-desktop" v-if="hasMoreThanOneFilter">


        <a href="#" v-if="!open" @click.prevent="toggleFilters()"><i class="fa fa-caret-down"></i></a>
        <a href="#" v-else @click.prevent="toggleFilters()"><i class="fa fa-caret-right"></i></a>

        <div v-if="open">
            <a @click.prevent="activateFilter(null)"
               :class="{ active: filter == null }" href="#" v-if="!hide_all">All</a>
            <a v-for="(filterLabel,filterValue) in filters" @click.prevent="activateFilter(filterValue)"
               :class="{ active: filter == filterValue }" href="#">{{ filterLabel }}</a>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                filters: [],
                hide_all: false,
                filter: null,
                open: false
            }
        },
        computed: {
            hasFilters: function () {
                return !_.isEmpty(this.filters);
            },
            hasMoreThanOneFilter: function(){
                var filterCount = Object.keys(this.filters).length;

                if(!this.hide_all)
                {
                    filterCount = filterCount + 1;
                }

                return filterCount > 1;
            }
        },
        watch: {
            filter: function (value) {

            },
            open: function (value) {
                if (value) {
                    $('#app-content').hide();
                    $('#contextual-navigation-trigger').hide();
                    $('#mobile-menu-button').hide();
                    $('#header-filler').show();
                } else {
                    $('#app-content').show();
                    $('#header-filler').hide();
                    $('#mobile-menu-button').show();
                    $('#contextual-navigation-trigger').show();
                }
            }
        },
        methods: {
            activateFilter: function (filterName) {
                eventBus.$emit('filter-bar-changed', filterName,this.filters[filterName]);
            },
            toggleFilters: function () {
                this.open = !this.open;
            }
        },
        mounted() {
            var that = this;

            eventBus.$on('filter-bar-changed', function (filterName) {
                that.filter = filterName;
                that.open = false;
            });

            eventBus.$on('filter-bar-set-filters', function (filters, hide_all) {
                that.filters = filters;
                if(hide_all)
                {
                    that.hide_all = true;
                }else{
                    that.hide_all = false;
                }
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../sass/setup';

    .filter-bar-header {
        display: inline;
        > a {
            margin-left: 8px;
            display: inline-block;
        }
        > div {
            text-align: center;
            padding-top: 1em;
        }
    }

    body.app #app-header .filter-bar-header div a {
        border-radius: $standardBorderRadius;
        display: block;
        text-align: center;
        margin-bottom: 0.5em;
        font-size: 18px;
        padding: 0.4em 0;

        &:last-of-type {
            margin-bottom: 0;
        }
        &.active, &:hover {
            background-color: rgba(255, 255, 255, 0.5);
        }
    }
</style>
